import React, { useEffect, useState } from 'react'

import { Picker, RadioGroup, Row, Span } from 'components'
import { DateTime } from 'services/database/reportsDatabase'
import { SPACING } from 'utils'
import { Moment } from 'moment'
import moment from 'moment'

export interface TypeDate {
  tipoRelatorio: number
  changeTipo: (x: number) => void
  setDataIni: (date: any) => void
  setDataFim: (date: any) => void
  dataIni?: Date | Moment
  dataFim?: Date | Moment
  isCompetencia?: boolean
}

interface ErrorsProps {
  initial?: string
  final?: string
}

const TypeDate: React.FC<TypeDate> = ({
  tipoRelatorio,
  dataFim,
  dataIni,
  setDataIni,
  setDataFim,
  changeTipo,
  isCompetencia
}) => {
  const tipoOptions = [
    { label: 'FR Bloqueadas', value: 0 },
    { label: 'FR Liberadas', value: 3 },
    { label: 'FR Bloqueadas com Desdobramento', value: 1 },
    { label: 'Fornecedor Bloqueado para Pagamento', value: 2 },
    { label: 'Todos os Fornecedores', value: 4 }
  ]

  const [errors, setErrors] = useState<ErrorsProps>({
    final: null,
    initial: null
  })

  function handlePickerDate(value: any, type: string) {
    if (type == 'initial') {
      if (moment(value).isValid()) {
        if (dataFim === null) {
          setDataIni(value)
        } else if (moment(value).isAfter(dataFim)) {
          setErrors({ initial: 'Data inicial deve ser maior que data final.' })
        } else {
          setDataIni(value)
        }
      }

      return
    }
    if (type == 'final') {
      if (moment(value).isValid()) {
        if (dataIni === null) {
          setDataFim(value)
        } else if (moment(value).isBefore(dataIni)) {
          setErrors({ final: 'Data fim deve ser maior que data inicial.' })
        } else {
          setDataFim(value)
        }
      }

      return
    }
  }

  return (
    <Row alignItems="center" justifyContent="space-between">
      <Row>
        <RadioGroup
          label="Tipo"
          row
          listOptions={tipoOptions}
          value={tipoRelatorio}
          formValue="tipoRelatorio"
          onChange={(e) => changeTipo(parseInt(e.target.value))}
        />
      </Row>
      <Row alignItems="flex-start">
        <Picker
          label="Período Bloqueio"
          value={dataIni}
          inputFormat="dd/MM/yyyy"
          // views={['year', 'month', 'day']}
          placeholder={'dd/mm/aaaa'}
          // onValid={(e) => setDataIni(e)}
          customError={errors?.initial}
          onChange={(value) => handlePickerDate(value, 'initial')}
          // type={'dayMonthYear'}
          removeButton
          maxDate={dataFim}
        />
        <Span
          text="à"
          fontSize="1rem"
          marginTop={SPACING.spacing30}
          marginLeft={SPACING.spacing10}
          marginRight={SPACING.spacing15}
        />
        <Picker
          label=""
          value={dataFim}
          inputFormat="dd/MM/yyyy"
          // views={['day', 'month', 'year']}
          placeholder={'dd/mm/aaaa'}
          removeButton
          // onValid={(e) => setDataFim(e)}
          customError={errors?.final}
          onChange={(value) => handlePickerDate(value, 'final')}
          minDate={dataIni}
        // type="dayMonthYear"
        />
      </Row>
    </Row>
  )
}

export default TypeDate
